import {
  type CSSProperties,
  type ElementType,
  type ReactElement,
  type ReactNode,
  createElement,
} from "react";

import { cx, styled } from "simplydo/react/styled";

import { ErrorLabel, StyledField, fieldWidthPct } from "./Form.styles";
import type { FormFieldProps } from "./Form.types";

const FormFieldComponent = (props: FormFieldProps): ReactElement => {
  const {
    as,
    children,
    content,
    className,
    style,
    control,
    disabled,
    error,
    id,
    inline,
    label,
    required,
    type,
    width,
    ...rest
  } = props;

  const Component = (as || "div") as ElementType;
  const errorMessage =
    error && typeof error !== "boolean" ? (error as ReactNode) : null;
  const widthPct = fieldWidthPct(width);

  const controlNode: ReactNode = control
    ? createElement(
        control,
        { id, type, disabled, error: Boolean(error), ...rest },
        content !== undefined ? (content as ReactNode) : children,
      )
    : content !== undefined
      ? (content as ReactNode)
      : children;

  return (
    <StyledField
      as={Component}
      className={cx(
        className,
        Boolean(error) && "is-error",
        disabled && "is-disabled",
        Boolean(required) && "is-required",
        inline && "is-inline",
        Boolean(widthPct) && "is-width",
      )}
      style={style as CSSProperties | undefined}
      $widthPct={widthPct}
    >
      {label != null && label !== false ? (
        <label htmlFor={id != null ? String(id) : undefined}>{label}</label>
      ) : null}
      {controlNode}
      {errorMessage ? <ErrorLabel>{errorMessage}</ErrorLabel> : null}
    </StyledField>
  );
};

export const FormField = styled(FormFieldComponent)``;
